// Seeded RNG (mulberry32). State is a plain number so it serializes with the World.
import type { RngState } from './types';

export function createRng(seed: number): RngState {
  // Mix the seed so nearby seeds do not produce correlated early values.
  let s = (seed ^ 0x9e3779b9) >>> 0;
  s = Math.imul(s ^ (s >>> 16), 0x45d9f3b) >>> 0;
  s = Math.imul(s ^ (s >>> 16), 0x45d9f3b) >>> 0;
  s = (s ^ (s >>> 16)) >>> 0;
  return { state: s };
}

/** Uniform float in [0, 1). Advances the state. */
export function nextFloat(rng: RngState): number {
  rng.state = (rng.state + 0x6d2b79f5) >>> 0;
  let t = rng.state;
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}

/** Uniform integer in [min, max] inclusive. */
export function nextInt(rng: RngState, min: number, max: number): number {
  return min + Math.floor(nextFloat(rng) * (max - min + 1));
}

/** True with probability p. */
export function chance(rng: RngState, p: number): boolean {
  return nextFloat(rng) < p;
}

export function pick<T>(rng: RngState, items: readonly T[]): T {
  const i = nextInt(rng, 0, items.length - 1);
  const item = items[i];
  if (item === undefined) {
    throw new Error('pick from empty list');
  }
  return item;
}
